













import { defineComponent } from "@vue/composition-api";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "CategoryDeleteConfirmation",
  components: { BaseConfirm, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    categoryId: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onDelete() {
      try {
        this.loading = true;
        const result = await providers.VaultsProvider.deleteCategory(this.categoryId);
        if (result) {
          this.$emit("delete");
        }
      } finally {
        this.loading = false;
      }
    },
  },
});
